const DEMO_KEY = 'leviathan_demo'
const DEMO_SLUG_KEY = 'leviathan_demo_slug'

export function isDemoMode(): boolean {
  try {
    return sessionStorage.getItem(DEMO_KEY) === 'true'
  } catch {
    return false
  }
}

export function enableDemoMode(): void {
  try {
    sessionStorage.setItem(DEMO_KEY, 'true')
  } catch {
    // sessionStorage not available
  }
}

export function disableDemoMode(): void {
  try {
    sessionStorage.removeItem(DEMO_KEY)
    sessionStorage.removeItem(DEMO_SLUG_KEY)
  } catch {
    // sessionStorage not available
  }
}

/** Remembers which demo variant (slug) is currently active. */
export function setActiveDemo(slug: string): void {
  try {
    sessionStorage.setItem(DEMO_KEY, 'true')
    sessionStorage.setItem(DEMO_SLUG_KEY, slug)
  } catch {
    // ignore
  }
}

export function getActiveDemoSlug(): string | null {
  try {
    return sessionStorage.getItem(DEMO_SLUG_KEY)
  } catch {
    return null
  }
}

export { DEMO_TENANTS, getDemoBySlug, listDemoSlugs, ACCENT_CLASSES } from './tenants'
export type { DemoTenantConfig, DemoAccentColor } from './tenants'
